/** Una cifra di punteggi e quote: larghezza tabellare fissa; cambiando `char` la chiave rimonta lo span e la cifra entra in dissolvenza. */
export function Flap({ char }: { char: string }) {
  return (
    <span className="inline-block tabular-nums">
      <span key={char} className="inline-block motion-safe:animate-flap">{char}</span>
    </span>
  )
}
